export default "/images/809be869d355518333632d3a49a46846.png";